import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import te from "./locales/te.json";

// Detect saved language from localStorage, fall back to English
const savedLanguage = localStorage.getItem("appLanguage") || "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    te: { translation: te },
  },
  lng: savedLanguage,
  fallbackLng: "en",
  interpolation: {
    // React already escapes values — no need for i18next to double-escape
    escapeValue: false,
  },
});

export default i18n;
